import { Spin } from "antd";
import React from "react";

const AppLoading = () => (
  <div
    style={{
      backgroundColor: "#fff",
      position: "fixed",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "32px",
    }}
  >
    <Spin></Spin>
  </div>
);

export default AppLoading;
